import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  RouteParamsTypes,
  Modules,
  NonAuthRoutes,
  PermissionModulesEnum,
  PermissionActionsEnum
} from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import PayoutList from '../modules/reconciliation/payout/list';

const Reconciliation: React.FC = () => {
  return (
    <Routes>
      <Route path={RouteParamsTypes.payout} element={<ProtectedRoute component={PayoutList} accessibleTo={[{ [PermissionModulesEnum.Reconciliation]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.any} element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />} />
    </Routes>
  );
};

export default Reconciliation;
